/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundInvokeResult {
    getFixupPrototypeFunction() { return AIPlaygroundInvokeResult.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundInvokeResult>): AIPlaygroundInvokeResult {
        let obj = Object.assign(new AIPlaygroundInvokeResult(), model);
        AIPlaygroundInvokeResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundInvokeResult>): AIPlaygroundInvokeResult {
        if (!model) return null;
        return AIPlaygroundInvokeResult.newInstance(<AIPlaygroundInvokeResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundInvokeResult) {
        if (!obj) return;

        models.AIPlaygroundInvokeResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundInvokeResult): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundInvokeResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.input_tokens === undefined) {
            this.input_tokens = 0;
        }
        if (this.latency_ms === undefined) {
            this.latency_ms = 0;
        }
        if (this.output_tokens === undefined) {
            this.output_tokens = 0;
        }
        if (this.prompt_input_cost === undefined) {
            this.prompt_input_cost = 0;
        }
        if (this.prompt_output_cost === undefined) {
            this.prompt_output_cost = 0;
        }
    }

    /**
     * Model completion text
     */
    completion: string;

    /**
     * Number of input tokens consumed
     */
    input_tokens: number;

    /**
     * End-to-end latency in milliseconds
     */
    latency_ms: number;

    /**
     * Bedrock model ID or inference profile ID
     */
    model_id: string;

    /**
     * Number of output tokens produced
     */
    output_tokens: number;

    /**
     * Unique identifier for the prompt invocation
     */
    prompt_id: string;

    /**
     * Input-side cost for the invocation
     */
    prompt_input_cost: number;

    /**
     * Output-side cost for the invocation
     */
    prompt_output_cost: number;

    /**
     * Bedrock stop reason
     */
    stop_reason: string;

}
